import { useNewCode } from '@calendly/feature-check-react';
import { useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { AIAssistantBanner, AI_ASSISTANT_BANNER_DISMISSED_KEY } from 'components/home/ai_assistant_banner';
import { CAF_EMAIL_AGENT_FEATURE } from 'constants/feature_flags';
import { useLocalStorageAlerts } from 'hooks/use_local_storage_alerts';
import { AIEmailAgentBannerDismissedContext } from './ai_email_banner_dismissed';
import { TabContent } from './tab_content';
import { TabNavigation } from './tab_navigation';
import { UpgradeInformer, UpgradeOverlayWrapper } from './upgrade_informer';
const bannerWrapperCss = "bvn605h";
const tabContentWithBannerCss = "t12pq2hy";
export const Scheduling = () => {
  const {
    pathname
  } = useLocation();
  const isCallieTab = pathname.startsWith('/app/scheduling/callie');
  const isCafEmailAgentFeatureEnabled = useNewCode(CAF_EMAIL_AGENT_FEATURE)?.enabled;
  const [isBannerDismissed, setIsBannerDismissed] = useState(() => localStorage.getItem(AI_ASSISTANT_BANNER_DISMISSED_KEY) === 'true');
  const contextValue = useMemo(() => ({
    isBannerDismissed,
    isCafEmailAgentFeatureEnabled,
    setIsBannerDismissed
  }), [isBannerDismissed, isCafEmailAgentFeatureEnabled]);
  useLocalStorageAlerts();
  const showAiAssistantBanner = isCafEmailAgentFeatureEnabled && !isBannerDismissed && !isCallieTab;
  return <AIEmailAgentBannerDismissedContext.Provider value={contextValue}>
      <TabNavigation />
      {showAiAssistantBanner && <div className={bannerWrapperCss}>
          <AIAssistantBanner onDismiss={() => setIsBannerDismissed(true)} />
        </div>}
      <UpgradeInformer />
      <UpgradeOverlayWrapper>
        <div className={showAiAssistantBanner ? tabContentWithBannerCss : undefined}>
          <TabContent />
        </div>
      </UpgradeOverlayWrapper>
    </AIEmailAgentBannerDismissedContext.Provider>;
};

require("./scheduling.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./scheduling.js");